module.exports = __webpack_public_path__ + "static/Ubuntu-Regular-2505bfbd9bde14a7829cc8c242a0d25c.ttf";